const TICKED = ["yes", "true", "1"];

/**
 * UAT Kenvue #55 (K1VAL xEVMPD-10014234): xEVMPD stores checkbox fields as text ("Yes" / "No"), but the shared view
 * widget ticks any non-empty value, so a stored "No" showed as ticked. For the view only, text values of checkbox
 * fields become booleans read the way the XML reads them (yes / true / 1 → ticked); the stored data is not changed.
 */
export const checkboxValuesForView = (fields: any[], formData: Record<string, any>) => {
  if (!formData || !Array.isArray(fields)) return formData;
  const keys = fields
    .filter((f) => f?.type === "checkbox" && f?.field)
    .map((f) => f.field)
    .filter((key) => typeof formData[key] === "string" && formData[key].trim() !== "");
  if (keys.length === 0) return formData;
  const viewData = { ...formData };
  keys.forEach((key) => {
    viewData[key] = TICKED.includes(formData[key].trim().toLowerCase());
  });
  return viewData;
};
